import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import '@mailflow/ui/styles/tokens.css';
import '@mailflow/ui/styles/base.css';
import '@mailflow/ui/styles/components.css';
import './styles/app.css';
import './styles/data.css';
import './styles/segments.css';
import './styles/campaigns.css';
import './styles/journeys.css';
import './styles/sendeprofil.css';
import './styles/crm.css';
import './styles/analytics.css';
// Zuletzt: die Mobil-Regeln muessen alles Vorherige ueberschreiben koennen.
import './styles/mobile.css';

import { createAppRouter } from './router.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Nach einem 401 nicht erneut versuchen — die Antwort waere dieselbe.
      retry: (failureCount, error) => {
        const status = (error as { status?: number }).status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const router = createAppRouter(queryClient);

const container = document.getElementById('root');
if (!container) throw new Error('Wurzelelement #root fehlt in index.html.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
